define('shared/remote/payment/ajax',[
    'shared/remote/ajax',
    'shared/lib/RSVP',
    'shared/lib/JSON3',
    'shared/util/hub',
    'shared/util/state'
], function(
    ajax,
    RSVP,
    JSON,
    hub,
    state
) {
    var DEBUG_STATE_PAYMENT_FAILURE = 'persistent.debugger_payment_failure';
    var DEBUG_STATE_REDEEM_FAILURE = 'persistent.debugger_redeem_failure';
    var API_CAPTURE_PATH_REGEX = '/1/api/commerce-gateway/order/.*?-capture';
    var API_REDEEM_PATH_REGEX = '/1/api/commerce-gateway/order/redeem';

    function getPaymentFailureResponse() {
        var xhr = {
            status:400,
            statusText: 'Bad Request',
            responseText: '{"Code":"Error_Capture","Message":"Process standalone capture failed with error: Error_PaymentGatewayReject - CyberSource rejected capture with reason code 231"}' 
        };
        xhr.responseJSON = JSON.parse(xhr.responseText);
        return RSVP.reject(xhr);
    }

    function getRedeemFailureResponse() {
        var xhr = {
            status:400,
            statusText: 'Bad Request',
            responseText: ' {"Code":"Error_Validation","Message":"Invalid offer for current redemption."}' 
        };
        xhr.responseJSON = JSON.parse(xhr.responseText);
        return RSVP.reject(xhr);
    }

    function enableDebugletOptions() {
        hub
            .get('/debuglet/settings')
            .then(function(settings){
                settings['Payment failure'] = {
                    getValue: function() {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve(false);
                            }
                            else {
                                state
                                    .get(DEBUG_STATE_PAYMENT_FAILURE)
                                    .then(function(values){
                                        resolve(values[0] && values[0].value || false);
                                    });
                            }
                        });
                    },
                    setValue: function(value) {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve();
                            }
                            else {
                                state
                                    .push(DEBUG_STATE_PAYMENT_FAILURE, {value: value})
                                    .then(function(){
                                        resolve();
                                    });
                            }
                        });
                    }
                };
                settings['Redeem failure'] = {
                    getValue: function() {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve(false);
                            }
                            else {
                                state
                                    .get(DEBUG_STATE_REDEEM_FAILURE)
                                    .then(function(values){
                                        resolve(values[0] && values[0].value || false);
                                    });
                            }
                        });
                    },
                    setValue: function(value) {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve();
                            }
                            else {
                                state
                                    .push(DEBUG_STATE_REDEEM_FAILURE, {value: value})
                                    .then(function(){
                                        resolve();
                                    });
                            }
                        });
                    }
                };
            });
    }

    function highOrderAjax(options) {
        var me = this;
        var args = arguments;
        var paymentAPIRegex = new RegExp(API_CAPTURE_PATH_REGEX, 'i');
        var redeemAPIRegex = new RegExp(API_REDEEM_PATH_REGEX, 'i');

        return RSVP.all([
                state.get(DEBUG_STATE_PAYMENT_FAILURE),
                state.get(DEBUG_STATE_REDEEM_FAILURE)
            ])
            .then(function(debugDips){
                var debugPaymentFailure = debugDips[0] && debugDips[0][0] && debugDips[0][0].value;
                var debugRedeemFailure = debugDips[1] && debugDips[1][0] && debugDips[1][0].value;

                if (debugPaymentFailure && paymentAPIRegex.test(options.url)) {
                    return getPaymentFailureResponse();
                }
                else if (debugRedeemFailure && redeemAPIRegex.test(options.url)) {
                    return getRedeemFailureResponse();
                }

                return ajax.apply(me, args);
            })
            .then(null, function(xhr){
                var err;
                if (
                    xhr.responseJSON && 
                    xhr.responseJSON.Code === 'Error_Capture' && 
                    paymentAPIRegex.test(options.url)
                ) {
                    err = new Error(xhr.responseJSON.Message || 'Payment rejected by server');
                    err.type = 'rejected';
                }
                else if (
                    // not checking it at the moment as the service is problematic
                    // if you redeem with a redemption code that is associated with invalid offer
                    // for the user, it returns 500 without anything in the response
                    // xhr.responseJSON && 
                    // xhr.responseJSON.Code === 'Error_Validation' &&
                    redeemAPIRegex.test(options.url)
                ) {
                    err = new Error(xhr.responseJSON && xhr.responseJSON.Message || 'Redemption code is invalid');
                    err.type = 'redemptionCodeInvalid';
                }

                if (!err) {
                    var msg = xhr.responseJSON && xhr.responseJSON.Message || 'Unknown error';
                    err = new Error(msg);
                    err.type = 'generic';
                }

                err.fatal = false;

                return RSVP.reject(err);
            });
    }

    enableDebugletOptions();

    return highOrderAjax;
});
